export default "__VITE_ASSET__hZXVD6ka__"